import { dmApi } from "../../../app/dmApi";
import { getAuthorizationHeader, handleQueryError, handleQueryErrorAndSuccess } from "../../../helpers/RtkQueryUtils";
import { serialize } from "../../../helpers/Utils";
export const coldstorageApi = dmApi.injectEndpoints({
    endpoints: (build) => ({
        createRecord: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/cold-storage/add`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['recordColdStorage', 'ripeningSummary'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Added", "Record")

            },

        }),
        searchRecord: build.query({
            query: (data) => {

                let paramData = serialize(data);

                return {
                    url: `/cold-storage?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['recordColdStorage'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getRecordById: build.query({
            query: (id) => {
                return {
                    url: `/cold-storage/${id}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['recordColdStorageById'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        updateRecord: build.mutation({
            query: ({ id, requestBody }) => {
                return {
                    url: `/cold-storage/update/${id}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['recordColdStorage', 'recordColdStorageById', 'ripeningSummary', 'ripeningRooms'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Record")
            },
        }),
        getRecordByPalletId: build.query({
            query: (id) => {
                return {
                    url: `/cold-storage/pallet/${id}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['recordColdStorageByPalletId'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        updateMultipleRecords: build.mutation({
            query: ({ requestBody }) => {
                return {
                    url: `/cold-storage/update-multiple-records`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['recordColdStorage', 'recordColdStorageById', 'ripeningSummary', 'ripeningRooms'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Record")
            },
        }),
    }),
});

export const {
    useCreateRecordMutation,
    useUpdateRecordMutation,
    useGetRecordByIdQuery,
    useSearchRecordQuery,
    useGetRecordByPalletIdQuery,
    useUpdateMultipleRecordsMutation
} = coldstorageApi;